<div class="report-administration__grid-container">
  <dx-data-grid
    #uploadsGrid
    class="report-administration__component"
    [dataSource]="historyDataSource"
    [showBorders]="false"
    [renderAsync]="true"
    [columnAutoWidth]="true"
    [columnHidingEnabled]="true"
    [allowColumnReordering]="true"
    [allowColumnResizing]="true"
    [remoteOperations]="true"
    [rowAlternationEnabled]="true"
    width="100%"
    height="100%"
  >
    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate>
          <div class="report-administration__toolbar-heading">
            <b class="report-administration__toolbar-title">Dashboard File Uploads</b>
          </div>
        </div>
      </dxi-item>

      <dxi-item location="after">
        <div *dxTemplate>
          <dx-button
            text="Upload file"
            icon="upload"
            type="default"
            stylingMode="contained"
            hint="Upload paid file"
            (onClick)="openUploadModal()"
          ></dx-button>
        </div>
      </dxi-item>

      <dxi-item name="searchPanel" cssClass="report-administration__toolbar-control"></dxi-item>
    </dxo-toolbar>

    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[25, 50, 100]" [showInfo]="true"></dxo-pager>
    <dxo-scrolling mode="virtual" [showScrollbar]="'always'"></dxo-scrolling>
    <dxo-load-panel [enabled]="true"></dxo-load-panel>

    <dxi-column dataField="fileName" caption="File Name" alignment="left" [minWidth]="230"></dxi-column>
    <dxi-column
      dataField="asOfDate"
      caption="As of Date"
      [dataType]="'date'"
      alignment="left"
      [width]="140"
      [format]="dateOnlyFormat"
    ></dxi-column>
    <dxi-column
      dataField="year"
      caption="Year"
      [dataType]="'number'"
      alignment="left"
      [width]="120"
      [sortIndex]="0"
      [sortOrder]="'desc'"
    >
      <dxo-lookup [dataSource]="years"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="createdByEmail" caption="Created By Email" alignment="left" [width]="230"></dxi-column>
    <dxi-column
      dataField="createdAt"
      caption="Created Date"
      [sortIndex]="1"
      [sortOrder]="'desc'"
      [dataType]="'datetime'"
      [width]="170"
      alignment="left"
      [format]="dateFormat"
    ></dxi-column>
    <dxi-column
      dataField="recordsImported"
      caption="Records"
      [dataType]="'number'"
      alignment="left"
      [width]="120"
      [format]="numberFormat"
    ></dxi-column>
    <dxi-column
      dataField="summariesGenerated"
      caption="Summaries"
      [dataType]="'number'"
      alignment="left"
      [width]="125"
      [format]="numberFormat"
    ></dxi-column>
    <dxi-column
      type="buttons"
      caption="Source File"
      alignment="center"
      [width]="110"
      [allowSorting]="false"
      [allowFiltering]="false"
    >
      <dxi-button name="download" template="sourceFileButtonTemplate"></dxi-button>
    </dxi-column>

    <div *dxTemplate="let cell of 'sourceFileButtonTemplate'">
      <ng-container *ngIf="hasSourceFile(cell.data)">
        <dx-load-indicator
          *ngIf="downloadingSourceFileId === cell.data.id; else downloadLinkTmpl"
          class="report-administration__download-indicator"
          [width]="18"
          [height]="18"
        ></dx-load-indicator>
        <ng-template #downloadLinkTmpl>
          <a
            class="dx-link dx-link-icon dx-icon-download report-administration__download-link"
            role="button"
            title="Download source file"
            (click)="downloadSourceFile(cell.data)"
          ></a>
        </ng-template>
      </ng-container>
    </div>
  </dx-data-grid>
</div>

<ag-shr-modal-window
  #uploadPaidFileModalRef
  [title]="'Upload Paid File'"
  [width]="720"
  [height]="'auto'"
  [inProgress]="formService.isBusy()"
  [useScrollView]="false"
  [actionTitle]="'IMPORT'"
  [actionIcon]="null"
  [saveButtonDisabled]="!formService.canImport()"
  [onCloseModal]="formService.allowClose"
  (onSaveClick)="formService.submit()"
  (onHidden)="handleUploadModalHidden()"
>
  <div
    *ngIf="uploadPaidFileModalRef?.popupComponent?.visible ?? false"
    class="report-administration-modal__content-container"
  >
    <dx-load-panel
      [visible]="formService.isImporting()"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [position]="{ of: '.report-administration-modal__content-container' }"
      message="Importing paid file..."
    ></dx-load-panel>

    <dx-form
      class="report-administration-modal__form"
      [formData]="formService.formDataSig()"
      [labelMode]="'floating'"
      [colCount]="2"
    >
      <dxi-item
        dataField="year"
        editorType="dxSelectBox"
        [editorOptions]="{
          items: years,
          searchEnabled: true,
          disabled: formService.isBusy(),
          placeholder: '',
        }"
        [label]="{ text: 'Year' }"
      ></dxi-item>

      <dxi-item
        dataField="asOfDate"
        editorType="dxDateBox"
        [editorOptions]="{
          type: 'date',
          disabled: formService.isBusy(),
          placeholder: '',
        }"
        [label]="{ text: 'As of Date' }"
      ></dxi-item>

      <dxi-item [colSpan]="2">
        <div *dxTemplate class="report-administration-modal__file-field">
          <div class="report-administration-modal__file-header">
            <span class="dx-field-item-label-text">Select / Drop files</span>
            <dx-button
              *ngIf="formService.file()"
              icon="close"
              stylingMode="text"
              hint="Clear selected file"
              [disabled]="formService.isBusy()"
              (onClick)="clearSelectedFile()"
            ></dx-button>
          </div>

          <dx-file-uploader
            #fileUploader
            class="report-administration-modal__file-uploader"
            selectButtonText="Select CSV"
            labelText="or drop the file here"
            accept=".csv"
            uploadMode="useForm"
            [multiple]="false"
            [showFileList]="true"
            [disabled]="formService.isBusy()"
            (onValueChanged)="formService.setFile($event.value?.[0] ?? null)"
          ></dx-file-uploader>
        </div>
      </dxi-item>
    </dx-form>

    <div *ngIf="formService.validationSummary() as validationSummary" class="report-administration-modal__summary">
      <h5>Summary</h5>
      <div class="report-administration-modal__summary-grid">
        <div>
          <span>Transactions to Import</span>
          <strong>{{ validationSummary.transactionsToImport | number: "1.0-0" }}</strong>
        </div>
        <div>
          <span>Summaries to Import</span>
          <strong>{{ validationSummary.summariesToImport | number: "1.0-0" }}</strong>
        </div>
        <div>
          <span>Premium Total</span>
          <strong>{{ validationSummary.premiumTotal | currency: "USD" : "symbol" : "1.2-2" }}</strong>
        </div>
        <div>
          <span>Policies</span>
          <strong>{{ validationSummary.policies | number: "1.0-2" }}</strong>
        </div>
      </div>
    </div>

    <div *ngIf="formService.validationMessages().length" class="report-administration-modal__messages">
      <div class="report-administration-modal__messages-title">Validation Messages</div>
      <dx-scroll-view [useNative]="false" [showScrollbar]="'always'" width="100%" height="120">
        <div
          *ngFor="let message of formService.validationMessages()"
          class="report-administration-modal__message"
          [class.report-administration-modal__message--error]="message.kind === 'error'"
        >
          {{ message.text }}
        </div>
      </dx-scroll-view>
    </div>
  </div>
</ag-shr-modal-window>
